var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author HyeongJin O
 * @contact hjoh@detech.co.kr
 * @date 2022-08-15
 * @brief EHP 기기등록 관리 - 일괄 등록 개발
 *
 ********************************************************************/
import React, { useEffect, useRef, useState } from "react";
// recoil
import { useRecoilValue } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
//
import * as XLSX from 'xlsx';
import { useTrans } from "../../../utils/langs/useTrans";
/**
 * @brief EHP 기기등록 관리 - 일괄 등록 컴포넌트 , 반응형 동작
 * @param -
 * @returns react components
 */
function DeviceBatch(props) {
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const curTree = props.curTree;
    const isMobile = props.isMobile;
    const setParentIsMobile = props.setIsMobile;
    const setParentPopWin = props.setPopWin;
    const setParentCurTree = props.setCurTree;
    const setParentWorkMode = props.setWorkMode;
    const restart = props.restart;
    const setRestart = props.setRestart;
    const [savedFiles, setSavedFiles] = useState([]);
    const [uploadFiles, setUploadFiles] = useState([]);
    const [fileName, setFileName] = useState('');
    const [uploadFileName, setUploadFileName] = useState('');
    const [excelArray, setExcelArray] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [status, setStatus] = useState([]);
    var j = 1;
    // 프로그래스바 액션
    const fileRef = useRef();
    //mobile check
    const mobileRef = useRef(null); // Mobile Check용
    useEffect(() => {
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (CUTIL.isnull(mobileRef))
            return;
        const mobileTag = mobileRef.current;
        if (!CUTIL.isnull(mobileTag)) {
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
    }, []);
    // 순차,기기유형,판넬명,정격전압,2차전압,정격전류,차단전류,정격용량,모델명,시리얼번호,제조사,메모 순
    let excelNoArr = excelArray.filter((list, idx) => (idx != 0) && (list.no)).map((list) => (list));
    // let heads = headers.map((list) => (list))
    const ingNum = Math.round(status.length / excelNoArr.length * 100);
    // 성공 및 실패 데이터
    let successData = [];
    let failData = [];
    for (let i = 0; i < status.length; i++) {
        if (status[i].data.msg == "fail") {
            failData.push(status[i].body);
        }
        else if (status[i].data.msg == "success") {
            successData.push(status[i].body);
        }
    }
    let arrarySuccess = [...successData];
    let arraryFail = [...failData];
    /*     useEffect(() => {
            setParentPopWin("pop-devicealladd",
                <MobileDeviceBatch
                    htmlHeader={<h1>{curTree.room.roomName}</h1>}
                    curTree={curTree}
                    isMobile={props.isMobile}
                    fileName={fileName}
                    setFileName={setFileName}
                    uploadFileName={uploadFileName}
                    setUploadFileName={setUploadFileName}
                    status={status}
                    setStatus={setStatus}
                    //
    
                    handleFileClick={handleFileClick}
                    handleFileClose={handleFileClose}
                    handleFileUolad={handleFileUolad}
                    //
                    arrarySuccess={arrarySuccess}
                    arraryFail={arraryFail}
                    ingNum={ingNum}
    
                />
    
            )
        }); */
    function finishList(e) {
        setParentPopWin("pop-finish-ok-web", React.createElement(FinishPop, { htmlHeader: React.createElement("h1", null, uploadFileName), excelArray: excelArray, status: status }));
        CUTIL.jsopen_Popup(e);
    }
    // 첨부파일 저장 // 엑셀 업로드 함수
    function handleOnChange(e) {
        const file = e.target.files[0];
        // 
        var reader = new FileReader();
        //데이터 포맷
        const formData = new FormData();
        formData.append("files", file);
        //엑셀 upload
        reader.onload = function () {
            var fileData = reader.result;
            var xlsxUpload = XLSX.read(fileData, { type: 'binary' });
            var xlsxSheet = xlsxUpload.Sheets[xlsxUpload.SheetNames[0]];
            var xlsxSheet1 = XLSX.utils.sheet_to_json(xlsxSheet);
            // 엑셀 헤드 추출
            var xlsxHeader = XLSX.utils.sheet_to_json(xlsxSheet, {
                header: 1,
                defval: ""
            });
            setExcelArray(xlsxSheet1);
            setHeaders(xlsxHeader);
        };
        reader.readAsBinaryString(file);
        setFileName(file.name);
        e.target.value = '';
        setUploadFileName("");
        setStatus([]);
    }
    ;
    // 첨부파일 불러오는 함수
    function handleFileClick(e) {
        fileRef.current.click();
    }
    function handleFileClose(delFile) {
        setFileName("");
        setUploadFileName("");
    }
    // update API
    function handleFileUolad(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            excelArray.filter(((list, idx) => (idx != 0) && (list.no))).forEach((list) => __awaiter(this, void 0, void 0, function* () {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "POST",
                    appPath: '/api/v2/product/company/zone/subzone/room/panel/itemseries',
                    appQuery: {
                        roomId: curTree.room.roomId,
                        excelNo: list.no,
                        spgName: list.spgName,
                        panelName: list.panelName,
                        modelName: list.modelName,
                        serialNo: list.serialNo,
                        ratingVoltage: list.ratingVoltage,
                        ratingCurrent: list.ratingCurrent,
                        cutoffCurrent: list.cutoffCurrent,
                        secondaryVoltage: list.secondaryVoltage,
                        ratedCapacity: list.ratedCapacity,
                        memo: list.memo
                    },
                    userToken: userInfo.loginInfo.token,
                });
                CUTIL.sleep(300);
                setStatus((status) => { return [...status, data]; });
            }));
            if (data) {
                handleFileClose(e);
                setUploadFileName(fileName);
                deviceNotic(curTree.room.roomId);
            }
        });
    }
    function deviceNotic(roomId) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: '/api/v2/product/company/zone/subzone/room/panel/item/itemseries/notice',
                appQuery: {
                    roomId: roomId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                }
                else {
                    alert(data.errorList.map((err) => (err.msg)));
                }
            }
        });
    }
    // add by sjpark 20220818
    function onClickDeviceTab(e, workMode) {
        setParentWorkMode(workMode);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right", ref: mobileRef },
            React.createElement("ul", { className: "page-loca" },
                React.createElement("li", null, curTree.company.companyName),
                React.createElement("li", null, curTree.zone.zoneName),
                React.createElement("li", null, curTree.subZone.subZoneName),
                React.createElement("li", null, curTree.room.roomName)),
            React.createElement("h2", null, curTree.room.roomName),
            React.createElement("div", { className: "inline mb-18" },
                React.createElement("a", { href: "#", className: "move-list", onClick: (e) => onClickDeviceTab(e, "LIST") }, "Device List"),
                React.createElement("ul", { className: "tab__small" },
                    React.createElement("li", { className: "on" },
                        React.createElement("a", { href: "#", className: "icon-add" }, t("LABEL.일괄등록"))),
                    React.createElement("li", null,
                        React.createElement("a", { href: "#", className: "icon-pen", onClick: (e) => onClickDeviceTab(e, "CREATE") }, t("LABEL.개별등록"))))),
            React.createElement("div", { className: "area__right_content hcal-170" },
                React.createElement("div", { className: "content__info" },
                    React.createElement("h3", { className: "hide" }, "\uC77C\uAD04\uB4F1\uB85D \uC785\uB825"),
                    React.createElement("div", { className: "drag__area" },
                        React.createElement("div", { className: "drag__left" },
                            React.createElement("button", { type: "button", className: "btn btn-filedown" },
                                React.createElement("a", { href: "https://repoehp.blob.core.windows.net/repoehp-item/item/\uAE30\uAE30\uC77C\uAD04\uB4F1\uB85D\uC591\uC2DD.xlsx" },
                                    React.createElement("span", null,
                                        " ",
                                        t("LABEL.excel")))),
                            React.createElement("div", { className: "filebox-drag" },
                                (fileName) &&
                                    React.createElement("ul", { className: "filelist" },
                                        React.createElement("li", null,
                                            React.createElement("span", null, fileName))),
                                React.createElement("p", { className: "tit" }, "File Upload"),
                                React.createElement("input", { ref: fileRef, type: "file", id: "file1", accept: ".xls,.xlsx", onChange: (e) => handleOnChange(e), style: { "display": "none" } }),
                                (!fileName) &&
                                    React.createElement("p", { className: "txt" },
                                        t("FIELD.첨부파일"),
                                        " ",
                                        React.createElement("button", { type: "button", onClick: (e) => handleFileClick(e) }, t("FIELD.선택"))),
                                React.createElement("div", { className: "btn__wrap" },
                                    (!fileName) ?
                                        React.createElement("button", { type: "button", className: "bg-gray", disabled: true },
                                            React.createElement("span", null, "Cancel"))
                                        :
                                            React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => handleFileClose(savedFiles) },
                                                React.createElement("span", null, "Cancel")),
                                    (!fileName) ?
                                        React.createElement("button", { type: "button", disabled: true },
                                            React.createElement("span", null, "Upload"))
                                        :
                                            React.createElement("button", { type: "button", onClick: (e) => handleFileUolad(e) },
                                                React.createElement("span", null, "Upload")))),
                            React.createElement("div", { className: "filebox-upload" },
                                React.createElement("p", { className: "tit" }, "File Upload"),
                                (!fileName) ?
                                    React.createElement("div", { className: "filebox", onClick: (e) => handleFileClick(e) },
                                        React.createElement("label", null,
                                            React.createElement("span", null, "\uCCA8\uBD80\uD30C\uC77C \uC120\uD0DD")))
                                    :
                                        React.createElement("div", { className: "flielist__upload" },
                                            React.createElement("ul", { className: "filelist" },
                                                React.createElement("li", null,
                                                    React.createElement("span", null, fileName),
                                                    React.createElement("button", { type: "button", className: "btn btn-delete", onClick: (e) => handleFileClose(e) },
                                                        React.createElement("span", { className: "hide" }, "\uC0AD\uC81C")))),
                                            React.createElement("button", { type: "button", className: "btn-upload", onClick: (e) => handleFileUolad(e) },
                                                React.createElement("span", null, "Upload"))))),
                        React.createElement("div", { className: "drag__right" },
                            React.createElement("ul", { className: "drag__right__list" },
                                ((uploadFileName)) &&
                                    React.createElement("li", null,
                                        React.createElement("p", { className: "tit" }, t("LABEL.진행중")),
                                        React.createElement("ul", { className: "drag-filelist" },
                                            React.createElement("li", null,
                                                React.createElement("p", { className: `name ${(ingNum == 100) ? "success" : ""}` }, uploadFileName),
                                                React.createElement("div", { className: "progressbar" },
                                                    React.createElement("div", { className: "progress-value" },
                                                        React.createElement("progress", { value: ingNum, max: "100" }),
                                                        React.createElement("p", { className: "value" },
                                                            React.createElement("span", null,
                                                                ingNum,
                                                                "%"))))))),
                                (ingNum == 100) &&
                                    React.createElement("li", null,
                                        React.createElement("p", { className: "tit" }, t("LABEL.진행완료")),
                                        React.createElement("ul", { className: "filelist-case" },
                                            React.createElement("li", null,
                                                React.createElement("p", { className: "name" }, uploadFileName),
                                                React.createElement("div", null,
                                                    React.createElement("p", { className: "case-ok" },
                                                        React.createElement("strong", null, t("LABEL.성공")),
                                                        React.createElement("span", null,
                                                            arrarySuccess.length,
                                                            "\uAC1C")),
                                                    React.createElement("p", { className: "case-no" },
                                                        React.createElement("strong", null, t("LABEL.실패")),
                                                        React.createElement("span", null,
                                                            arraryFail.length,
                                                            "\uAC1C")),
                                                    React.createElement("button", { type: "button", className: "btn-go js-open", "data-pop": "pop-finish-ok-web", onClick: (e) => finishList(e) },
                                                        React.createElement("span", { className: "hide" }, "\uD31D\uC5C5\uCC3D \uC5F4\uAE30"))))))))))))));
}
export default DeviceBatch;
// function MobileDeviceBatch(props) {
//     const t =useTrans();
//     //
//     const isMobile = props.isMobile;
//     const fileName = props.fileName
//     const setFileName = props.setFileName
//     const handleFileClick = props.handleFileClick
//     const handleFileClose = props.handleFileClose
//     const handleFileUolad = props.handleFileUolad
//     const uploadFileName = props.uploadFileName
//     const setUploadFileName = props.setUploadFileName
//     const status = props.status
//     const setStatus = props.setStatus
//     const arrarySuccess = props.arrarySuccess
//     const arraryFail = props.arraryFail
//     const ingNum = props.ingNum
//     return (
//         <>
//             <div className="popup__body">
//                 <div className="area__right_content workplace__info info__input">
//                     <div className="content__info">
//                         <h3 className="hide">일괄등록 입력</h3>
//                         <div className="drag__area">
//                             <div className="drag__left">
//                                 <button type="button" className="btn btn-filedown">
//                                     <a href="https://repoehp.blob.core.windows.net/repoehp-item/item/기기일괄등록양식.xlsx">
//                                         <span>Excel {t("LABEL.excel")}</span>
//                                     </a>
//                                 </button>
//                                 {/* <!--탭사이즈부터숨김, 1470px--> */}
//                                 <div className="filebox-drag">
//                                     <p className="tit">File Upload</p>
//                                     <p className="txt">첨부파일 드래그 또는 <button type="button">선택</button></p>
//                                     <div className="btn__wrap">
//                                         <button type="button" className="bg-gray" disabled><span>Cancel</span></button>
//                                         <button type="button" disabled><span>Upload</span></button>
//                                     </div>
//                                 </div>
//                                 {/* <!--탭사이즈부터노출, 1470px--> */}
//                                 <div className="filebox-upload">
//                                     <p className="tit">File Upload</p>
//                                     {(!fileName) ?
//                                         <div className="filebox" onClick={(e) => handleFileClick(e)}>
//                                             <label><span>첨부파일 선택</span></label>
//                                             {/* <input type="file" id="file2" accept=".xls,.xlsx" onChange={(e) => handleOnChange(e)} /> */}
//                                         </div>
//                                         :
//                                         <div className="flielist__upload">
//                                             <ul className="filelist">
//                                                 <li>
//                                                     <span>{fileName}</span>
//                                                     <button type="button" className="btn btn-delete" onClick={(e) => handleFileClose(e)}><span className="hide">삭제</span></button>
//                                                 </li>
//                                             </ul>
//                                             <button type="button" className="btn-upload" onClick={(e) => handleFileUolad(e)}><span>Upload</span></button>
//                                         </div>
//                                     }
//                                 </div>
//                             </div>
//                             <div className="drag__right">
//                                 <ul className="drag__right__list">
//                                     {(uploadFileName) &&
//                                         <li>
//                                             <p className="tit">진행 중</p>
//                                             <ul className="drag-filelist">
//                                                 {/* <!--파일 완료되면 success 클래스 추가-->  */}
//                                                 <li>
//                                                     <p className={`name ${(ingNum == 100) ? "success" : ""}`}>{uploadFileName}</p>
//                                                     <div className="progressbar">
//                                                         <div className="progress-value">
//                                                             <progress value={ingNum} max="100"></progress>
//                                                             <p className="value"><span>{ingNum}%</span></p>
//                                                         </div>
//                                                     </div>
//                                                 </li>
//                                             </ul>
//                                         </li>
//                                     }
//                                     {(ingNum == 100) &&
//                                         <li>
//                                             <p className="tit">진행 완료</p>
//                                             <ul className="filelist-case">
//                                                 <li>
//                                                     <p className="name">{uploadFileName}</p>
//                                                     <div>
//                                                         <p className="case-ok"><strong>성공</strong><span>{arrarySuccess.length}개</span></p>
//                                                         <p className="case-no"><strong>실패</strong><span>{arraryFail.length}개</span></p>
//                                                         <button type="button" className="btn-go js-open-s-in" data-pop="pop-finish-ok" onClick={(e) => CUTIL.jsopen_s_in_Popup(e, isMobile)}><span className="hide">팝업창 열기</span></button>
//                                                     </div>
//                                                 </li>
//                                             </ul>
//                                         </li>
//                                     }
//                                 </ul>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// }
function FinishPop(props) {
    //trans
    const t = useTrans();
    //
    const excelArray = props.excelArray;
    const status = props.status;
    const data = (status === null) ? null : status;
    const [displayChang, setDisplayChang] = useState(false);
    const [dataFail, setDataFail] = useState([]);
    let successData = [];
    let successList = [];
    let failData = [];
    let failFieldList = [];
    for (let i = 0; i < status.length; i++) {
        if (status[i].data.msg == "fail") {
            failData.push(status[i].body);
        }
        else if (status[i].data.msg == "success") {
            successData.push(status[i].body);
        }
    }
    let arrarySuccess = [...successData];
    let arraryFail = [...failData];
    useEffect(() => {
        setDisplayChang(false);
    }, []);
    function displayChangs(e) {
        if (displayChang === false) {
            setDisplayChang(true);
        }
        else {
            setDisplayChang(false);
        }
    }
    function listDoen(e) {
        setDisplayChang(false);
        var btnCommentClose = document.getElementById("pop-finish-ok-web");
        var body = document.body;
        var dimm = body.querySelector(".dimm");
        if (!CUTIL.isnull(body))
            body.setAttribute("style", "overflow-y: auto;");
        if (!CUTIL.isnull(dimm))
            dimm.setAttribute("style", "display: none; z-index: 11;");
        if (!CUTIL.isnull(btnCommentClose))
            btnCommentClose.classList.add("hidden");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("ul", { className: "tab__button" },
                React.createElement("li", { className: (!displayChang) ? "on" : "" },
                    React.createElement("a", { href: "#", className: "green", onClick: (e) => displayChangs(e) }, t("LABEL.성공"))),
                React.createElement("li", { className: (displayChang) ? "on" : "" },
                    React.createElement("a", { href: "#", className: "red", onClick: (e) => displayChangs(e) }, t("LABEL.실패")))),
            React.createElement("div", { className: "tbl-list hcal-77" },
                (!displayChang) &&
                    React.createElement("table", { summary: "No,\uAE30\uAE30 \uBD84\uB958,Panel \uBA85,\uAE30\uAE30 \uBA85,\uC81C\uC870\uBC88\uD638,\uC815\uACA9\uC804\uC555 (kV),\uC815\uACA9\uC804\uB958 (A),\uCC28\uB2E8\uC804\uB958 (A)\uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC9C4\uD589\uC644\uB8CC \uC131\uACF5 \uBAA9\uB85D \uC785\uB2C8\uB2E4." },
                        React.createElement("caption", null, "\uC9C4\uD589\uC644\uB8CC \uC131\uACF5 \uBAA9\uB85D"),
                        React.createElement("colgroup", null,
                            React.createElement("col", { style: {} })),
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", { scope: "col", className: "txt-left" },
                                    React.createElement("span", null, t("FIELD.No"))),
                                React.createElement("th", { scope: "col", className: "txt-left d-sm-none" }, t("FIELD.기기분류")),
                                React.createElement("th", { scope: "col", className: "txt-left d-sm-none" }, t("FIELD.Panel명")),
                                React.createElement("th", { scope: "col", className: "txt-left" },
                                    React.createElement("span", null, t("FIELD.모델명"))),
                                React.createElement("th", { scope: "col", className: "txt-left" },
                                    React.createElement("span", null, t("FIELD.시리얼번호"))),
                                React.createElement("th", { scope: "col", className: "txt-left d-sm-none" },
                                    t("FIELD.정격전압"),
                                    " "),
                                React.createElement("th", { scope: "col", className: "txt-left d-sm-none" },
                                    t("FIELD.정격전류"),
                                    " "),
                                React.createElement("th", { scope: "col", className: "txt-left d-sm-none" },
                                    t("FIELD.차단전류"),
                                    " "),
                                React.createElement("th", { scope: "col", className: "txt-left d-sm-none" },
                                    t("FIELD.정격용량"),
                                    " "),
                                React.createElement("th", { scope: "col", className: "txt-left d-sm-none" },
                                    t("FIELD.2차전압"),
                                    " "),
                                React.createElement("th", { scope: "col", className: "txt-left d-sm-none" }, t("FIELD.제조사")))),
                        React.createElement("tbody", null, arrarySuccess.map((data, idx) => (React.createElement("tr", { key: data.itemId },
                            React.createElement("td", { className: "txt-left" }, [++idx]),
                            React.createElement("td", { className: "txt-left d-sm-none" }, data.spgName),
                            React.createElement("td", { className: "txt-left d-sm-none" }, data.panelName),
                            React.createElement("td", { className: "txt-left", title: data.modelName },
                                React.createElement("p", { className: "ellipsis wmax-200" }, data.modelName)),
                            React.createElement("td", { className: "txt-left", title: data.serialNo },
                                React.createElement("p", { className: "ellipsis" }, data.serialNo)),
                            React.createElement("td", { className: "txt-left d-sm-none" }, data.ratingVoltage),
                            React.createElement("td", { className: "txt-left d-sm-none" }, data.ratingCurrent),
                            React.createElement("td", { className: "txt-left d-sm-none" }, data.cutoffCurrent),
                            React.createElement("td", { className: "txt-left d-sm-none" }, data.ratedCapacity),
                            React.createElement("td", { className: "txt-left d-sm-none" }, data.secondaryVoltage),
                            React.createElement("td", { className: "txt-left d-sm-none" }, data.manufacturer)))))),
                (displayChang) &&
                    React.createElement("table", { summary: "No,\uAE30\uAE30 \uBD84\uB958,Panel \uBA85,\uAE30\uAE30 \uBA85,\uC81C\uC870\uBC88\uD638,\uC815\uACA9\uC804\uC555 (kV),\uC815\uACA9\uC804\uB958 (A),\uCC28\uB2E8\uC804\uB958 (A)\uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC9C4\uD589\uC644\uB8CC \uC2E4\uD328 \uBAA9\uB85D \uC785\uB2C8\uB2E4." },
                        React.createElement("caption", null, "\uC9C4\uD589\uC644\uB8CC \uC2E4\uD328 \uBAA9\uB85D"),
                        React.createElement("colgroup", null,
                            React.createElement("col", { style: {} })),
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", { scope: "col", className: "txt-left" },
                                    React.createElement("span", null, "No.")),
                                React.createElement("th", { scope: "col", className: "txt-left" }, "Excel No."),
                                React.createElement("th", { scope: "col", className: "txt-left" },
                                    React.createElement("span", null, t("FIELD.모델명"))),
                                React.createElement("th", { scope: "col", className: "txt-left" },
                                    React.createElement("span", null, t("FIELD.시리얼번호"))),
                                React.createElement("th", { scope: "col", className: "txt-left" }, t("FIELD.실패사유")))),
                        React.createElement("tbody", null, arraryFail.map((data, idx) => (React.createElement("tr", { key: idx },
                            React.createElement("td", { className: "txt-left wvalue-30" }, [++idx]),
                            React.createElement("td", { className: "txt-left wvalue-60" }, data.excelNo),
                            React.createElement("td", { className: "txt-left", title: data.modelName },
                                React.createElement("p", { className: "ellipsis wmax-200" }, data.modelName)),
                            React.createElement("td", { className: "txt-left", title: data.serialNo },
                                React.createElement("p", { className: "ellipsis" }, data.serialNo)),
                            React.createElement("td", { className: "txt-left" }, data.errorList[0].field + " " + data.errorList[0].msg))))))),
            React.createElement("div", { className: "tbl__bottom" }, (!displayChang) ?
                React.createElement("p", { className: "result__num" },
                    "Result ",
                    React.createElement("span", null, arrarySuccess.length))
                :
                    React.createElement("p", { className: "result__num" },
                        "Result ",
                        React.createElement("span", null, arraryFail.length)))),
        React.createElement("div", { className: "popup__footer brd-0" },
            React.createElement("button", { className: "button  js-close", onClick: (e) => listDoen(e) },
                React.createElement("span", null, t("LABEL.확인"))))));
}
// function FinishPopMobile(props) {
//     const excelArray = props.excelArray;
//     const status = props.status
//     const data = (status === null) ? null : status
//     const [displayChang, setDisplayChang] = useState(false)
//     const [dataFail, setDataFail] = useState([])
//     let successData = []
//     let failData = []
//     for (let i = 0; i < status.length; i++) {
//         if (status[i].data.msg == "fail") {
//             failData.push(status[i].body)
//         } else if (status[i].data.msg == "success") {
//             successData.push(status[i].body)
//         }
//     }
//     let arrarySuccess = [...successData]
//     let arraryFail = [...failData]
//     function displayChangs(e) {
//         if (displayChang === false) {
//             setDisplayChang(true)
//         } else {
//             setDisplayChang(false);
//         }
//     }
//     return (
//         <>
//             {/* <!--일괄 등록 내 진행 완료 성공 팝업, 220801 추가 --> */}
//             <div className="popup__body">
//                 <ul className="tab__button mt-16 mb-16">
//                     {/* <!-- 선택된 탭 on --> */}
//                     <li className={(!displayChang) ? "on" : ""}><a className="green" onClick={(e) => displayChangs(e)} >성공!</a></li>
//                     <li className={(displayChang) ? "on" : ""}><a className="red" onClick={(e) => displayChangs(e)}>실패</a></li>
//                 </ul>
//                 {(!displayChang) && <div className="tbl-list type4">
//                     <table summary="No.,기기 명,제조번호 항목으로 구성된 진행완료 성공 리스트 입니다.">
//                         <caption>
//                             진행완료 성공 리스트
//                         </caption>
//                         <colgroup>
//                             <col style={{}} />
//                         </colgroup>
//                         <tbody>
//                             {arrarySuccess.map((list, idx) => {
//                                 <tr key={list.itemId}>
//                                     <td>
//                                         <ul>
//                                             <li>
//                                                 <strong>No.</strong>
//                                                 <span>{idx++}</span>
//                                             </li>
//                                             <li>
//                                                 <strong>모델 명</strong>
//                                                 <span>{list.modelName}</span>
//                                             </li>
//                                             <li>
//                                                 <strong>제조번호</strong>
//                                                 <span>{list.serialNo}</span>
//                                             </li>
//                                         </ul>
//                                     </td>
//                                 </tr>
//                             })}
//                         </tbody>
//                     </table>
//                 </div>}
//                 {(displayChang) &&
//                     <div className="tbl-list type4">
//                         <table summary="Excel No., 기기 명, 제조번호, 실패사유 항목으로 구성된 진행완료 실패 리스트 입니다.">
//                             <caption>
//                                 진행완료 실패 리스트
//                             </caption>
//                             <colgroup>
//                                 <col style={{}} />
//                             </colgroup>
//                             <tbody>
//                                 {arraryFail.map((list, idx) => (
//                                     <tr key={idx}>
//                                         <td>
//                                             <ul>
//                                                 <li>
//                                                     <strong>Excel No.</strong>
//                                                     <span>{list.excelNo}</span>
//                                                 </li>
//                                                 <li>
//                                                     <strong>모델 명</strong>
//                                                     <span>{list.modelName}</span>
//                                                 </li>
//                                                 <li>
//                                                     <strong>시리얼번호</strong>
//                                                     <span>{list.serialNo}</span>
//                                                 </li>
//                                                 <li>
//                                                     <strong>실패사유</strong>
//                                                     <span>{list.errorList[0].field + " " + list.errorList[0].msg}</span>
//                                                 </li>
//                                             </ul>
//                                         </td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 }
//             </div>
//             {/* <!-- //일괄 등록 내 진행 완료 성공 팝업, 220801 추가 --> */}
//             {/* <!--일괄 등록내 진행 완료 실패 팝업, 220801 추가 --> */}
//         </>
//     )
// }
